import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { MenuService } from 'src/app/components/menu/menu.service';
import { AlertType } from 'src/app/shared/models/alert.model';
import { TerminoService } from 'src/app/components/contenido/containers/termino/termino.service';
import { TerminosCondicionesService } from 'src/app/shared/services/terminos-condiciones.service';
import { ModalTerminoCondicionesComponent } from '../../layouts/modal-termino-condiciones/modal-termino-condiciones.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { UtilService } from 'src/app/shared/services/util.service';
import { EstablecimientoComercioService } from '../../../core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { ModalAjusteRntComponent } from 'src/app/components/core/layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';
import { DataSharedService } from '../../../../shared/services/data-shared.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	formLogin: FormGroup;
	constructor(private authService: AuthService, private formBuilder: FormBuilder,
		private router: Router, private alertsService: AlertsService, private modalService: NgbModal,
		private menuService: MenuService, private terminosCondicionesService: TerminosCondicionesService,
		private establecimientoComercioService: EstablecimientoComercioService) {
	}

	ngOnInit() {
		this.formLogin = this.formBuilder.group({
			username: ['', Validators.required],
			password: ['', Validators.required],
			recordarme: ['']
		});
	}

	onLogin() {
		this.terminosCondicionesService.validarTerminos({ usuario: this.formLogin.value.username }).subscribe(resultadoTerminos => {
			if (resultadoTerminos.result) {
				if (resultadoTerminos.data) {
					this.authService.login(this.formLogin.value.username,UtilService.encrypt(this.formLogin.value.password)).subscribe(resultado => {
						if (resultado.result) {
							this.authService.setToken(resultado.data);
							this.menuService.get(null).subscribe(resultadoRol => {
								if (resultadoRol.result && resultadoRol.data) {
									if (this.authService.getRolUser(RolesUsuario.Prestador)) {
										this.authService.sincronizar().subscribe();
									}
									if (this.authService.getRolUser(RolesUsuario.Funcionario) ||
										this.authService.getRolUser(RolesUsuario.SoloConsulta) ||
										this.authService.getRolUser(RolesUsuario.SoloConsultaNacional) ||
										this.authService.getRolUser(RolesUsuario.Prestador)) {
										if (resultadoRol.data.horizontal && resultadoRol.data.horizontal.length > 0) {
											localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
											this.router.navigate([resultadoRol.data.horizontal[0].ruta_url]);
										} else if (resultadoRol.data.vertical && resultadoRol.data.vertical.length > 0) {
											this.router.navigate(['/perfil']);
											localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
										} else {
											this.alertsService.alert(AlertType.Error,
												'El usuario no cuenta con los permisos suficientes para ingresar.', '/login', resultado.control.code.toString(), true);
										}
									} else {
										this.router.navigate(['/perfil']);
										localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
									}
								}
							});
						}
					});
				} else {
					this.terminosCondicionesService.getTextoPlano(null).subscribe(resultTC => {
						if (resultTC.result) {
							const modalRef = this.modalService.open(ModalTerminoCondicionesComponent, { centered: true });
							modalRef.componentInstance.terminos = resultTC.data[0];
							modalRef.result.then((resultModalTC) => {
								this.authService.login(this.formLogin.value.username, this.formLogin.value.password).subscribe(resultado => {
									if (resultado.result) {
										this.authService.setToken(resultado.data);
										this.terminosCondicionesService.aceptarTerminos({ usuario: this.formLogin.value.username }).subscribe(resultadoACT => {
											if (resultadoACT.result) {
												this.menuService.get(null).subscribe(resultadoRol => {
													if (resultadoRol.result && resultadoRol.data) {
														if (this.authService.getRolUser(RolesUsuario.Prestador)) {
															this.authService.sincronizar().subscribe();
														}
														if (this.authService.getRolUser(RolesUsuario.Funcionario) ||
															this.authService.getRolUser(RolesUsuario.SoloConsulta) ||
															this.authService.getRolUser(RolesUsuario.SoloConsultaNacional) ||
															this.authService.getRolUser(RolesUsuario.Prestador)) {
															if (resultadoRol.data.horizontal && resultadoRol.data.horizontal.length > 0) {
																
																this.router.navigate([resultadoRol.data.horizontal[0].ruta_url]);
																localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
															} else if (resultadoRol.data.vertical && resultadoRol.data.vertical.length > 0) {
																this.router.navigate(['/perfil']);
																localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
															} else {
																this.alertsService.alert(AlertType.Error,
																	'El usuario no cuenta con los permisos suficientes para ingresar.', '/login', resultado.control.code.toString(), true);
															}
														} else {
															this.router.navigate(['/perfil']);
															localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
														}
													}
												});
											}
										});
									}
								});
							});
						}
					});
				}
			}
		});
	}
	
	
}


